<template>
    <div class="d-flex flex-column align-center justify-center">
        <div class="d-flex flex-column justify-center">
            <div class="d-flex flex justify-center font-weight-bold text-body-1 primary--text text--lighten-1 mb-2">
                {{ label }}
            </div>
            <input ref="fileInput" type="file" style="display: none;" accept=".jpg, .jpeg, .pdf"
                @change="handleFileUpload">
            <v-card v-if="loading" class="d-flex flex align-center justify-center" min-width="176" width="176"
                height="110">
                <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
            </v-card>
            <div v-else>
                <v-card v-if="!imagePreview" class="d-flex flex justify-center rounded-0" elevation="6" min-width="176"
                    width="176" height="110" @click=handleFileImport>
                    <v-img src="@/assets/inputs/dni-frente.png" contain></v-img>
                </v-card>
            </div>
            <v-btn v-if="!imagePreview" :disabled="loading" elevation="0" small color="primary" class="pa-5 rounded-0"
                @click=handleFileImport>
                <v-icon class="mr-2">mdi-plus</v-icon>
                cargar archivo
            </v-btn>
            <canvas ref="canvas" style="display: none;"></canvas>
            <v-card v-if="imagePreview" min-width="176" width="176" height="110" class="justify-center align-center"
                :color="(fileName) ? 'grey lighten-2' : ''">
                <div v-if="fileName" class="d-flex mt-2 flex-column justify-center align-center">
                    <img :src="imagePreview" alt="Archivo .pdf cargado" width="60">
                    <v-chip dense>{{ fileName }}</v-chip>
                </div>
                <div v-else class="d-flex flex justify-center">
                    <img :src="imagePreview" alt="Imagen previa" min-width="176" height="110">
                </div>
            </v-card>
            <v-btn v-if="imagePreview" elevation="0" :disabled="habilitarEliminar" outlined @click="deleteImage"
                color="error" class="py-5 px-10 rounded-0">
                <v-icon class="mr-2">mdi-delete-outline</v-icon>
                eliminar
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import imagePdf from '@/assets/pdf-ok-20.png'

export default {
    data() {
        return {
            selectedFiles: [],
            imagePreview: null,
            fileSizeError: false,
            loading: false,
            fileSizeErrorMessage: '',
            image: imagePdf,
            fileName: ''

        };
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated']),

        habilitarEliminar() {
            return (this.disabled)
        }
    },
    methods: {
        ...mapActions('dataUser', ['addFiles']),
        ...mapActions('preafiliacion', ['addFilesPre']),

        handleFileImport() {
            // Trigger click on the FileInput
            try {
                this.$refs.fileInput.click();
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },

        handleFileUpload(event) {
            const file = event.target.files[0]
            const tipo = event.target.files[0].type
            const size = event.target.files[0].size
            if (file) {
                this.loading = true
                if ((tipo == 'image/jpeg' || tipo == 'image/jpg' || tipo == 'image/png') && (size <= 5 * 1024 * 1024)) {
                    this.fileSizeError = false;
                    this.compressAndConvertToPNG(file)
                        .then(imageUrl => {
                            this.selectedFiles.push(file);
                            (this.isAuthenticated) ? this.addFiles({ file: file, op: this.op }) : this.addFilesPre({ file: file, op: this.op })
                            this.$emit('fileSelected')
                            this.showImagePreview(imageUrl);
                        })
                        .catch(error => {
                            console.error('Error al procesar la imagen:', error);
                        }).finally(() => {
                            this.loading = false
                        });
                }
                /* || tipo == 'image/jpeg' || tipo == 'image/jpg' || tipo == 'image/png') && (file.size <= 5 * 1024 * 1024) */
                else if ((tipo == 'application/pdf') && (size <= 5 * 1024 * 1024)) {
                    this.selectedFiles.push(file);
                    (this.isAuthenticated) ? this.addFiles({ file: file, op: this.op }) : this.addFilesPre({ file: file, op: this.op })
                    this.$emit('fileSelected')
                    this.showImagePreview(this.image)
                    this.fileName = file.name
                } else {
                    this.reduceImageSize(file, 800).then(reducedFile => {
                        this.compressAndConvertToPNG(reducedFile).then(imageUrl => {
                            // this.selectedFiles.push(reducedFile)
                            (this.isAuthenticated) ? this.addFiles({ file: reducedFile, op: this.op }) : this.addFilesPre({ file: reducedFile, op: this.op })
                            this.$emit('fileSelected');
                            this.showImagePreview(imageUrl)
                        })
                    })
                }
            } else {
                this.loading = false
                console.log('error')
            }
        },
        reduceImageSize(file, maxWidth) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        const aspectRatio = img.width / img.height;
                        let newWidth = maxWidth;
                        let newHeight = maxWidth / aspectRatio;
                        if (img.width > maxWidth) {
                            canvas.width = newWidth;
                            canvas.height = newHeight;
                            ctx.drawImage(img, 0, 0, newWidth, newHeight);
                            canvas.toBlob((blob) => {
                                const reducedFile = new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() });
                                resolve(reducedFile);
                            }, 'image/jpeg');
                        } else {
                            resolve(file); // No es necesario reducir el tamaño
                        }
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            });
        },

        compressAndConvertToPNG(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = this.$refs.canvas;
                        const ctx = canvas.getContext('2d');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);
                        canvas.toBlob((blob) => {
                            const imageUrl = URL.createObjectURL(blob);
                            resolve(imageUrl);
                        }, 'image/png');
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        showImagePreview(imageUrl) {
            this.loading = false
            this.imagePreview = imageUrl;
        },
        deleteImage() {
            this.selectedFiles = [];
            (this.isAuthenticated) ? this.addFiles({ file: '', op: this.op }) : this.addFilesPre({ file: '', op: this.op })
            this.$emit('fileSelected')
            this.imagePreview = null;
            this.fileName = '';
            this.$refs.fileInput.value = ''; // Limpiar el valor del input file
        },
    },
    props: ['label', 'op', 'disabled']
};
</script>

<style>
.card-image {
    padding: auto;
}
</style>
